import type { Icon } from "@tabler/icons-react";

export type CountryCode = "NG" | "GH" | "ZA" | "EG";

export interface Country {
  code: CountryCode;
  name: string;
  flagEmoji: string;
  currencyCode: string;
  currencySymbol: string;
}

export interface ComplianceService {
  id: string;
  name: string;
  description: string;
  icon: Icon;
}

export interface BusinessTypeOption {
  id: string;
  name: string;
}

export interface CompanyDetails {
  companyName: string;
  businessType: string;
  registeredAddress: string;
  contactEmail: string;
  contactPhone: string;
  shareCapital: string;
  numberOfDirectors: string;
  natureOfBusiness: string;
}

export const emptyCompanyDetails: CompanyDetails = {
  companyName: "",
  businessType: "",
  registeredAddress: "",
  contactEmail: "",
  contactPhone: "",
  shareCapital: "",
  numberOfDirectors: "",
  natureOfBusiness: "",
};

export interface ChatMessage {
  id: string;
  role: "user" | "assistant";
  content: string;
}

export type WizardStepId = "country" | "company" | "ai" | "generate";

export interface WizardStep {
  id: WizardStepId;
  label: string;
}
